export default {
    "CREATE_PROGRESS_BAR": "CREATE_PROGRESS_BAR",
    "UPDATE_PROGRESS_BAR": "UPDATE_PROGRESS_BAR",
    "REMOVE_PROGRESS_BAR": "REMOVE_PROGRESS_BAR"
}